import { render, staticRenderFns } from "./DetailedPagination.vue?vue&type=template&id=11d0a9cc&"
import script from "./DetailedPagination.vue?vue&type=script&lang=js&"
export * from "./DetailedPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports